if (!customElements.get('fdp-shipping-announcement')) {
  customElements.define('fdp-shipping-announcement', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.slides = [...this.querySelectorAll('.fdp-shipping-announcement__slide')];
      this.track = this.querySelector('.fdp-shipping-announcement__track');
      this.dots = [...this.querySelectorAll('[data-slide]')];
      this.pauseButton = this.querySelector('[data-pause]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.index = 0;
      this.paused = this.motion.matches;
      this.hovered = false;
      this.focused = false;
      this.start = null;
      this.swiped = false;
      this.querySelectorAll('[hidden]').forEach(el => { el.hidden = false; });
      this.querySelector('[data-prev]').addEventListener('click', () => this.show(this.index - 1), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1), options);
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index), options));
      this.pauseButton.addEventListener('click', () => { this.paused = !this.paused; this.sync(); }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', () => queueMicrotask(() => { this.focused = this.contains(document.activeElement); this.schedule(); }), options);
      this.addEventListener('pointerdown', event => { this.start = [event.clientX, event.clientY]; this.swiped = false; this.schedule(); }, options);
      document.addEventListener('pointerup', event => {
        if (!this.start) return;
        const dx = event.clientX - this.start[0];
        const dy = event.clientY - this.start[1];
        this.start = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { this.swiped = true; this.show(this.index + (dx < 0 ? 1 : -1)); }
        this.schedule();
      }, options);
      this.addEventListener('pointercancel', () => { this.start = null; this.schedule(); }, options);
      this.addEventListener('click', event => { if (this.swiped) { event.preventDefault(); this.swiped = false; } }, { ...options, capture: true });
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.paused = true; this.sync(); }, options);
      this.show(0);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.track.style.transform = `translateX(-${this.index * 100}%)`;
      this.slides.forEach((slide, i) => { const active = i === this.index; slide.inert = !active; slide.tabIndex = active ? 0 : -1; slide.setAttribute('aria-hidden', String(!active)); });
      this.dots.forEach((dot, i) => { if (i === this.index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
      this.sync();
    }
    sync() {
      this.pauseButton.setAttribute('aria-pressed', String(this.paused));
      this.pauseButton.setAttribute('aria-label', this.paused ? '自動切り替えを再開' : '自動切り替えを停止');
      this.pauseButton.textContent = this.paused ? '▶' : 'Ⅱ';
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.isConnected || this.paused || this.hovered || this.focused || this.start || document.hidden) return;
      this.timer = setTimeout(() => this.show(this.index + 1), 7000);
    }
  });
}
